import { useCallback, useEffect, useMemo, useState } from 'react'

const RAZORPAY_CHECKOUT_SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js'

const useRazorpayCheckout = () => {
    const isClient = useMemo(() => typeof window !== 'undefined', [])
    const checkScriptLoaded = useCallback(() => {
        return !(!isClient || !('Razorpay' in window))
    }, [])

    const [isLoaded, setIsLoaded] = useState(checkScriptLoaded())

    const loadScript = useCallback(scriptUrl => {
        if (!isClient) return // Don't execute this function if it's rendering on server side
        return new Promise((resolve, reject) => {
            const scriptTag = document.createElement('script')
            scriptTag.src = scriptUrl
            scriptTag.onload = ev => {
                setIsLoaded(true), resolve(ev)
            }
            scriptTag.onerror = err => reject(err)
            document.body.appendChild(scriptTag)
        })
    }, [])

    useEffect(() => {
        if (!checkScriptLoaded()) {
            ;(async () => {
                try {
                    await loadScript(RAZORPAY_CHECKOUT_SCRIPT)
                } catch (error) {
                    throw new Error(error)
                }
            })()
        }
    }, [])

    const initiatePayment = options => {
        if (isLoaded) {
            let rzp = new window.Razorpay(options)
            rzp.open()
        }
    }

    return {
        isLoaded,
        initiatePayment,
    }
}

export default useRazorpayCheckout
